import React from 'react';

const Error404 = () => {
  return (
    <div className="min-h-[60vh] flex items-center justify-center px-6 py-16">
      <div className="text-center max-w-2xl">
        <h1 className="text-6xl font-extrabold text-purple-600">404</h1>
        <h2 className="mt-4 text-2xl font-semibold">Aradığınız sayfayı bulamadık</h2>
        <p className="mt-3 text-gray-600">
          Sayfa taşınmış, silinmiş veya geçici olarak kullanılamıyor olabilir. URL'yi kontrol edin veya anasayfaya dönün.
        </p>
        <div className="mt-8 flex items-center justify-center gap-3">
          <a href="/" className="px-4 py-2 bg-purple-600 text-white rounded hover:bg-purple-700">Anasayfaya Dön</a>
          <a href="/iletisim" className="px-4 py-2 border rounded">İletişime Geç</a>
        </div>
      </div>
    </div>
  );
};

export default Error404;




